import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";

const AbsenceDaysReasonContent = ({ data }) => {
    useEffect(() => {

        const labels = [];
        const values = [];

        data?.reasonDistribution.forEach(element => {
            labels.push(element.reason);
            values.push(element.totalDays);
        })

        GraphicUtils.barChart('absenceDaysByReason', values.slice(0, 10), labels.slice(0, 10));
        ReportUtils.createExportableTable(labels, values, 'Dias ausentes por motivos')
    }, [data]);

    return (
        <>
            <div className="chart-report">
                <span className="chart-title">Dias ausentes por motivos {data?.reasonDistribution?.length > 10 ? ' (TOP 10)' : ''}</span>
                <div id="absenceDaysByReason"/>
            </div>

            <div className="chart-divisor print-hide"/>
        </>
    );
};

export default AbsenceDaysReasonContent;